import { ReduxHelper } from "helpers";
import {
  IImportMaterialRequirementRequest,
  IMaterialRequirementCreateSuggestPalletRequest,
  IUpdateMaterialRequirementRequest,
} from "model";

export const prefix = "MATERIAL_REQUIREMENT";

export const importMaterial = ReduxHelper.generateActions<
  IImportMaterialRequirementRequest,
  any
>(prefix, "IMPORT_MATERIAL_REQUIREMENT");

export const importMoveMaterial = ReduxHelper.generateActions<
  IImportMaterialRequirementRequest,
  any
>(prefix, "IMPORT_MOVE_MATERIAL");

export const importMoveBag = ReduxHelper.generateActions<
  IImportMaterialRequirementRequest,
  any
>(prefix, "IMPORT_MOVE_BAG");
export const updateMaterialRequirement = ReduxHelper.generateActions<
  IUpdateMaterialRequirementRequest,
  any
>(prefix, "UPDATE_MATERIAL_REQUIREMENT");
export const clearAction = ReduxHelper.generateLocalAction(
  prefix,
  "CLEAR_ACTION"
);
export const createBookedPallet = ReduxHelper.generateActions<
  IMaterialRequirementCreateSuggestPalletRequest,
  any
>(prefix, "CREATE_BOOKED_PALLET");
